import type { ClassificationRule } from "@/services/api/classification-rules";
import {
  sortBy,
  comparators,
  type SortDirection,
} from "@/shared/lib/sortUtils";

export type SortField =
  | "category"
  | "value"
  | "weight"
  | "isActive"
  | "targets";
export type { SortDirection };

export function sortClassificationRules(
  rules: ClassificationRule[],
  sortField: SortField,
  sortDirection: SortDirection
): ClassificationRule[] {
  return sortBy(rules, sortField, sortDirection, {
    category: comparators.string((rule) => rule.category),
    value: comparators.string((rule) => rule.value),
    weight: comparators.number((rule) => rule.weight),
    isActive: comparators.boolean((rule) => rule.isActive),
    targets: comparators.string((rule) => (rule.targets ?? []).join(", ")),
  });
}
